// MIT License - Copyright (c) 2026 Doug McNall

/**
 * Stats Tracker
 * Tracks player progression stats for rank system
 */

import STORAGE_KEYS from '../system/STORAGE_KEYS';

class StatsTracker {
  constructor() {
    this.stats = this.load();
  }

  load() {
    return {
      systemsVisited: parseInt(localStorage.getItem(STORAGE_KEYS.SYSTEMS_VISITED) || '0'),
      combatWins: parseInt(localStorage.getItem(STORAGE_KEYS.COMBAT_WINS) || '0'),
      totalCreditsEarned: parseInt(localStorage.getItem(STORAGE_KEYS.TOTAL_CREDITS_EARNED) || '0'),
      missionsCompleted: parseInt(localStorage.getItem(STORAGE_KEYS.MISSIONS_COMPLETED) || '0'),
      aliensEncountered: parseInt(localStorage.getItem(STORAGE_KEYS.ALIENS_ENCOUNTERED) || '0'),
      distanceTraveled: parseFloat(localStorage.getItem(STORAGE_KEYS.DISTANCE_TRAVELED) || '0')
    };
  }

  save() {
    Object.entries(this.stats).forEach(([key, value]) => {
      localStorage.setItem(key, value.toString());
    });
  }

  visitSystem(systemId) {
    const visited = JSON.parse(localStorage.getItem(STORAGE_KEYS.VISITED_SYSTEMS) || '[]');
    if (!visited.includes(systemId)) {
      visited.push(systemId);
      localStorage.setItem(STORAGE_KEYS.VISITED_SYSTEMS, JSON.stringify(visited));
      this.stats.systemsVisited = visited.length;
      this.save();
    }
  }

  recordCombatWin() {
    this.stats.combatWins++;
    this.save();
  }

  recordCreditsEarned(amount) {
    this.stats.totalCreditsEarned += amount;
    this.save();
  }

  recordMissionComplete() {
    this.stats.missionsCompleted++;
    this.save();
  }

  recordAlienEncounter(alienId) {
    const encountered = JSON.parse(localStorage.getItem(STORAGE_KEYS.ENCOUNTERED_ALIENS) || '[]');
    if (!encountered.includes(alienId)) {
      encountered.push(alienId);
      localStorage.setItem(STORAGE_KEYS.ENCOUNTERED_ALIENS, JSON.stringify(encountered));
      this.stats.aliensEncountered = encountered.length;
      this.save();
    }
  }

  recordTravel(distance) {
    this.stats.distanceTraveled += distance;
    this.save();
  }

  getStats() {
    return { ...this.stats };
  }

  reset() {
    this.stats = {
      systemsVisited: 0,
      combatWins: 0,
      totalCreditsEarned: 0,
      missionsCompleted: 0,
      aliensEncountered: 0,
      distanceTraveled: 0
    };
    this.save();
    localStorage.removeItem(STORAGE_KEYS.VISITED_SYSTEMS);
    localStorage.removeItem(STORAGE_KEYS.ENCOUNTERED_ALIENS);
  }
}

// Singleton instance
const statsTracker = new StatsTracker();

export default statsTracker;
